module.exports = __webpack_public_path__ + "img/zc-04.30d0f1cb.svg";